"use client";

import React from "react";
import { Button } from "@wtc/ui";
import { Info } from "lucide-react";

interface NoCompanyStepProps {
  onClose: () => void;
}

export function NoCompanyStep({ onClose }: NoCompanyStepProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-start gap-3 p-4 bg-blue-50 dark:bg-blue-950/40 border border-blue-200 dark:border-blue-800 rounded">
        <Info className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
        <div>
          <div className="font-medium text-blue-900 dark:text-blue-200">No Company Linked</div>
          <div className="text-sm text-blue-800 dark:text-blue-200 mt-1">
            This contact doesn&apos;t have a company linked yet. Please link a company first before
            searching for decision makers.
          </div>
        </div>
      </div>

      <Button onClick={onClose} className="w-full">
        Close
      </Button>
    </div>
  );
}
